import { render, staticRenderFns } from "./BusinessSearch.vue?vue&type=template&id=ec56b700&scoped=true&"
import script from "./BusinessSearch.vue?vue&type=script&lang=js&"
export * from "./BusinessSearch.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSearch.vue?vue&type=style&index=0&id=ec56b700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec56b700",
  null
  
)

export default component.exports